/* global google:readonly */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";

import Button from "@material-ui/core/Button";

const GoogleLogin = compose()(
	({ client_id, scope, callback, button_name, ...props }) => {
		const [googleClient, setGoogleClient] = useState();
		const loadScript = (cb) => {
			((d, s, id) => {
				const element = d.getElementsByTagName(s)[0];
				const fjs = element;
				let js = element;
				js = d.createElement(s);
				js.id = id;
				js.src = "https://accounts.google.com/gsi/client";
				if (fjs && fjs.parentNode) {
					fjs.parentNode.insertBefore(js, fjs);
				} else {
					d.head.appendChild(js);
				}
				js.onload = cb;
			})(document, "script", "google-login");
		};

		useEffect(() => {
			loadScript(() => {
				setGoogleClient(
					google.accounts.oauth2.initTokenClient({
						client_id,
						scope,
						callback: (tokenResponse) => {
							callback(tokenResponse.access_token);
						},
					})
				);
			});
		}, []);

		const getLoginStatus = () => {
			googleClient.requestAccessToken();
		};

		const loginOnClickHandler = () => {
			if (!googleClient) return console.error("google libs not loaded");
			getLoginStatus();
		};

		return (
			<Button {...props} onClick={loginOnClickHandler}>
				{button_name ? button_name : "Sign up with Google"}
			</Button>
		);
	}
);

GoogleLogin.propTypes = {
	client_id: PropTypes.string.isRequired,
	callback: PropTypes.func.isRequired,
	scope: PropTypes.string.isRequired,
};

GoogleLogin.defaultProps = {
	openid_realm: null,
	login_hint: null,
	scope: "profile email",
	//accessType: "online",
	prompt: "",
	cookie_policy: "single_host_origin",
	//fetchBasicProfile: true,
	//isSignedIn: false,
	ux_mode: "popup",
	redirect_uri: null,
};

export default GoogleLogin;
